import React from "react";
import "./Footer.css";
import aqt from "../../assets/images/aqt.png";
import { Link } from "react-router-dom";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import EmailIcon from "@mui/icons-material/Email";
import FacebookRoundedIcon from "@mui/icons-material/FacebookRounded";
import TelegramIcon from "@mui/icons-material/Telegram";
import XIcon from "@mui/icons-material/X";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import YouTubeIcon from "@mui/icons-material/YouTube";
import InstagramIcon from "@mui/icons-material/Instagram";
import { Container } from "@mui/system";

export default function Footer() {
  return (
    <>
      <div className="mainFooter">
        <Container>
          <div className="blocks">
            <div className="block1">
              <img src={aqt} alt="AQT Direct Logo" />
              <p style={{ textAlign: "start", color: "white" }}>
                AQT Direct Ltd is a distinguished Private Equity Consultancy
                dedicated to assisting individuals in becoming Partners and
                Angel Investors in Early-Stage, High-Growth Potential Public
                Businesses gearing up for Initial Public Offerings (IPOs). We
                provide a comprehensive range of services essential for Private
                Equity Investors, including Market Research, Due Diligence,
                Auditing, Transaction Execution, and Compliance of Private
                Placements.
              </p>
            </div>

            <div className="block2">
              <h1 className="anchorfoot">Quick Links</h1>
              <div className="anchor">
                <Link className="insideanch" to="/about">
                  About Us
                </Link>
                <Link className="insideanch" to="/fundraise">
                  Fundraise
                </Link>
                <Link className="insideanch" to="/smeloans">
                  SME Loans
                </Link>
                <Link className="insideanch" to="/buysell">
                  Buysell
                </Link>
                <Link className="insideanch" to="/contactus">
                  Contact Us
                </Link>
                <Link className="insideanch" to="/blogs">
                  Blogs
                </Link>
              </div>
            </div>

            <div className="block4">
              <h1 className="anchorfoot1">Our Offices</h1>
              <p className="pfooter">
                <LocationOnIcon />
                <b>Mumbai Office: &nbsp;&nbsp;&nbsp;</b> Enam Sambhav, G Block,
                Bandra Kurla Complex, Mumbai, Maharashtra 400051
              </p>
              <p className="pfooter">
                <LocationOnIcon />
                <b>Noida Office:</b> 910-911, Iconic Tower, Corenthum, Sec-62,
                Noida(U.P) &nbsp; &nbsp;
              </p>
              {/* <p className="pfooter">
              <LocationOnIcon />
              <b>Gurugram Office:</b> 11A Tower B3 GF, Spaze I-Tech Park, Sohna Road, Sector 49, Gurugram 122018
            </p> */}
              <p className="pfooter" id="footmail">
                <EmailIcon />
                &nbsp;info@aqtdirect.com
              </p>
              <div className="iconfooter">
                <a
                  href="https://www.facebook.com/people/AQT-Direct-Limited/100089150012120/"
                  target="_blank"
                >
                  {" "}
                  <FacebookRoundedIcon className="icon" />
                </a>

                <a
                  href="https://in.linkedin.com/company/aqtdirectlimited"
                  target="_blank"
                >
                  {" "}
                  <LinkedInIcon className="icon" />
                </a>
                <a
                  href="https://www.instagram.com/be_a_shark_aqtdirect/"
                  target="_blank"
                >
                  {" "}
                  <InstagramIcon className="icon" />
                </a>
                {/* <TelegramIcon className="icon" /> */}
                {/* <YouTubeIcon className="icon" /> */}
              </div>
            </div>
          </div>
          <div className="botfoot">
            ©2018-2025 AQT Direct Limited. All Rights Reserved.
            &nbsp;&nbsp;&nbsp;&nbsp;CIN : U70200MH2023PLC399088
          </div>
        </Container>
      </div>
    </>
  );
}
